import { Component, inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconButton } from '@angular/material/button';
import { OrderByModule } from '@lib/util';
import { TranslateModule } from '@ngx-translate/core';
import { FrameContractSelection } from '../model/frame-contract-selection';

@Component({
    selector: 'frame-contract-selection-dialog',
    imports: [MatIconButton, OrderByModule, TranslateModule],
    templateUrl: './frame-contract-selection-dialog.component.html',
    styleUrl: './frame-contract-selection-dialog.component.scss',
})
export class FrameContractSelectionDialogComponent {
    dialogRef = inject<MatDialogRef<FrameContractSelectionDialogComponent>>(MatDialogRef);
    data = inject(MAT_DIALOG_DATA);


    public cancel(): void {
        this.dialogRef.close();
    }

    public save(frameContractSelection: FrameContractSelection): void {
        this.dialogRef.close(frameContractSelection);
    }
}
